import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Img1 from "../../images/services-usa/and/Why-Choose.webp";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {Link} from 'gatsby';

const Whychooseusa = () => {
  return (
    <div className="whychooseusa p-100">
        <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={10} lg={10} xl={10} xxl={10} className="m-auto text-center">
                        <h2><span>Why Choose</span> TekRevol For IP Protection Services?</h2>
                    </Col>
                </Row>
                <Row className="h-100 choose_padd">
                <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                    <p>In the dynamic journey of startup growth, the value of intellectual property often gets overlooked.</p>
                    <p>From logos to software patents, these assets are vulnerable to replication for quick gains.</p>
                    <p>TekRevol's IP protection services recognize this threat, employing Big Data tools and automated techniques to scan the web for copyright infringement, brand collateral misspells, and other deceptive practices.</p>
                    <p>We ensure your innovative ideas remain secure, safeguarding your startup against potential threats in the realm of Intellectual Property theft.</p>
                    <Link to="/contact"
                                  className="border_btn dark_btn" aria-label="TekRevol Contact">Consult with Us Today</Link>
                </Col>
                <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
                <LazyLoadImage
                            src={Img1}
                            effect="blur" alt="tekrevol_android" className="img-fluid"
                        />
                </Col>
                </Row>
            </Container>
    </div>
  )
}

export default Whychooseusa